function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31.993,
  cy: 31.993,
  r: 31.295,
  fill: "#FFF8FA",
  stroke: "#CA3232",
  strokeWidth: 1.397,
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55.485,
  cy: 53.828,
  r: 11.705,
  fill: "#FFF",
  stroke: "#CA3232"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CA3232",
  fillRule: "nonzero",
  stroke: "#CA3232",
  strokeWidth: 0.5,
  d: "M56.76 54l4.059-4.076c.217-.217.217-.562 0-.761-.218-.217-.562-.217-.761 0L56 53.239l-4.076-4.076c-.217-.217-.562-.217-.761 0-.217.217-.217.562 0 .76L55.221 54l-4.058 4.076c-.217.217-.217.562 0 .761.109.109.254.163.38.163.127 0 .272-.054.38-.163L56 54.761l4.076 4.076c.109.109.254.163.38.163.127 0 .272-.054.381-.163.217-.217.217-.562 0-.76L56.761 54z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M48.2 18v12h-5v13h-8l-1-4 2-2-1-2-1-1h-8v-3h-5V19l2-3h5l2 4 4 2 5-2 2-4h5l2 2z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#CA3232",
  strokeWidth: 1.3,
  transform: "translate(18.2 16)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.236 14.836h5.55v-11.1c0-2.043-1.656-3.7-3.7-3.7h-3.792c-.448 3.181-3.17 5.547-6.383 5.547S7.976 3.217 7.53.036H3.736c-2.043 0-3.7 1.657-3.7 3.7v11.1h5.55",
  transform: "translate(2.533)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.586 9.286L5.586 27.786 22.236 27.786 22.236 9.286",
  transform: "translate(2.533)"
})), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 18.194,
  fill: "#FFF",
  rx: 2.294
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 23.128,
  fill: "#FFF",
  rx: 2.294
}), /*#__PURE__*/React.createElement("rect", {
  width: 17.744,
  height: 4.589,
  x: -0.65,
  y: 28.061,
  fill: "#FFF",
  rx: 2.294
})));

function SvgNofolding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNofolding);
export default __webpack_public_path__ + "static/media/nofolding.fb467930.svg";
export { ForwardRef as ReactComponent };